import { TarifPublicService } from './../../Service/tarif-publics.service';
import { Component, OnInit } from '@angular/core';
import { Global } from 'src/app/Service/global.service';
import { SharedService } from 'src/app/Service/shared.service';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { sp } from "@pnp/sp";
import "@pnp/sp/webs";
import "@pnp/sp/lists";
import { timeStamp } from 'console';

@Component({
  selector: 'app-tarifs-publics-plafonds',
  templateUrl: './tarifs-publics-plafonds.component.html',
  styleUrls: ['./tarifs-publics-plafonds.component.scss']
})
export class TarifsPublicsPlafondsComponent implements OnInit {
  constructor(private global: Global,  private shared: SharedService, private service:TarifPublicService, private router: Router) { }
  currentLg ;
  bloc = {
    Titre: "",
    Contenu: ""
  }
  blocFooter1 = {
    Titre: "",
    Contenu: ""
  }
  blocFooter2 = {
    Titre: "",
    Contenu: ""
  }
  listTarif = '';
  tarifs = [];
  ports = [];
  prestations = [];
 sousPrestation = [];
  terminals =[];
  sensTraffics = [];
  selectedTarifs = [];
  selectedValues = {
    Title: '',
    Famille_Prestation: '',
    Terminal: '',
    Sens: '',
    Sous_prestation : ''
  };

  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      this.currentLg = lg;
      if(lg.code.toUpperCase() === 'FR') {
        this.shared.getBlocDescriptionByCode(lg.url, "Tarifs-Publics-Plafonds").subscribe(data => {
          this.bloc.Titre = data["value"][0] ? data["value"][0].Title : "";
          this.bloc.Contenu = data["value"][0] ? data["value"][0].Contenu : "";
        });
        this.shared.getBlocDescriptionByCode(lg.url, "Tarifs-Publics-Plafonds-footer1").subscribe(data => {
          this.blocFooter1.Titre = data["value"][0] ? data["value"][0].Title : "";
          this.blocFooter1.Contenu = data["value"][0] ? data["value"][0].Contenu : "";
        });
        this.shared.getBlocDescriptionByCode(lg.url, "Tarifs-Publics-Plafonds-footer2").subscribe(data => {
          this.blocFooter2.Titre = data["value"][0] ? data["value"][0].Title : "";
          this.blocFooter2.Contenu = data["value"][0] ? data["value"][0].Contenu : "";
        });
        this.shared.getBlocDescriptionByCode(lg.url, "Current_Tarification_List").subscribe(datas => {
          this.tarifs = [];
          this.ports = [];
          this.prestations = [];
          this.terminals =[];
          this.sensTraffics = [];
          this.sousPrestation = [];
        
          this.listTarif = datas["value"][0] ? datas["value"][0].Title : "";
          this.service.getTarif(lg.url, this.listTarif).subscribe( dataTarifs => {
          
            this.tarifs = dataTarifs["value"];
            this.tarifs.forEach(element => {
              if(this.ports.indexOf(element.Title) === -1) {
                this.ports.push(element.Title);
              }
            });
          })
        });
      } else {
        this.router.navigate(['/']);
      }
    

    })
  }
  changePorts() {
    this.selectedValues['Terminal'] = '';
    this.selectedValues['Famille_Prestation'] = '';
    this.selectedValues['Sous_prestation'] = '';
    this.selectedValues['Sens'] = '';
    this.prestations = [];
    this.terminals =[];
    this.sousPrestation =[];
    this.sensTraffics = [];
    this.selectedTarifs = [];
    this.tarifs.forEach(element => {
       if(this.prestations.indexOf(element.Famille_Prestation) === -1 && element.Title === this.selectedValues['Title']) {
          this.prestations.push(element.Famille_Prestation);
      }
    })
  }
  changeFamille() {
    this.selectedValues['Sous_prestation'] = '';
    this.selectedValues['Terminal'] = '';
    this.selectedValues['Sens'] = '';
    this.terminals =[];
    this.sensTraffics = [];
    this.selectedTarifs = [];
   
    this.tarifs.forEach(element => {
       if(this.terminals.indexOf(element.Terminal) === -1 && element.Title === this.selectedValues['Title'] && element.Famille_Prestation === this.selectedValues['Famille_Prestation']) {
          this.terminals.push(element.Terminal);
      }
    })
  }
  changeTerminal() {
    this.selectedValues['Sens'] = '';
    this.sensTraffics = [];
    this.selectedTarifs = [];
    this.sousPrestation =[];
    this.tarifs.forEach(element => {
       if(this.sousPrestation.indexOf(element.Sous_prestation) === -1 && element.Title === this.selectedValues['Title'] 
       && element.Famille_Prestation === this.selectedValues['Famille_Prestation']   && element.Terminal === this.selectedValues['Terminal']  ) {
          this.sousPrestation.push(element.Sous_prestation);
      }
    })
  }
  changeSousFamille() {
    this.selectedValues['Sens'] = '';
    this.sensTraffics = [];
    this.selectedTarifs = [];
    this.tarifs.forEach(element => {
       if(this.sensTraffics.indexOf(element.Sens) === -1 && element.Title === this.selectedValues['Title'] && element.Sous_prestation === this.selectedValues['Sous_prestation'] 
       && element.Famille_Prestation === this.selectedValues['Famille_Prestation']   && element.Terminal === this.selectedValues['Terminal'] 
       && element.Sens !== null && element.Sens !== '' ) {
          this.sensTraffics.push(element.Sens);
      }
    })
  }
  rechercheTarifs() {
    this.selectedTarifs = [];

    this.tarifs.forEach(element => {
      if(element.Title === this.selectedValues['Title'] && element.Sous_prestation === this.selectedValues['Sous_prestation'] 
      && element.Famille_Prestation === this.selectedValues['Famille_Prestation']   && element.Terminal === this.selectedValues['Terminal'] 
       && (this.selectedValues['Sens'] === '' || ( element.Sens !== '' && element.Sens === this.selectedValues['Sens'])))
         this.selectedTarifs.push(element);
     });

  }
}
